import { render, staticRenderFns } from "./AdvanceRegistrationApprovalComplete.vue?vue&type=template&id=16e64338"
import script from "./AdvanceRegistrationApprovalComplete.vue?vue&type=script&lang=ts"
export * from "./AdvanceRegistrationApprovalComplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports